import React from 'react';

import {ClickAwayListener, MenuList, Paper, Popper} from '@mui/material';
import {Theme} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {useTreeViewContext} from 'components/ContextMenu/hooks/useTreeViewContext';
import ExpandCollapse from '../ContextItems/folders/ExpandCollapse';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

const useStyles = makeStyles((theme: Theme) => ({
   popper: {
      zIndex: theme.zIndex.modal,
   },
   listPaper: {
      backgroundColor: theme.palette.grey[50],
      color: 'black',
      // minHeight: '3rem',
   },
}));

export const ExpandCollapseContextMenu = () => {
   const {data, anchorEl, handleClose} = useTreeViewContext();
   const classes = useStyles();
   const open = Boolean(anchorEl);
   return data?.objectType === DiplomatObjectType.enum.FOLDER ? (
      <Popper
         anchorEl={anchorEl}
         open={open}
         placement="bottom-start"
         role={undefined}
         className={classes.popper}
         // disablePortal
         // transition
      >
         {/* Produced a glitches because of stopImmediatePropagation on open {({TransitionProps}) => (
            <Grow
               {...TransitionProps}
               style={{
                  transformOrigin: 'top',
               }}
            > */}
         <Paper className={classes.listPaper} color="default">
            <ClickAwayListener onClickAway={handleClose}>
               <MenuList autoFocusItem={open} variant="menu">
                  <ExpandCollapse data={data} />;
               </MenuList>
            </ClickAwayListener>
         </Paper>
         {/* </Grow>
         )} */}
      </Popper>
   ) : null;
};
